import React, { useEffect } from 'react';
import CompanyInfo from '../components/CompanyInfo';
import OurApps from '../components/OurApps';
import DraggableStickers from '../components/DraggableStickers';
import { trackPageView } from '../utils/analytics';

const Home = () => {
  useEffect(() => {
    trackPageView('Home');
  }, []);

  return (
    <div className="container">
      {/* 左侧公司介绍区域 */}
      <div className="left-section">
        <CompanyInfo />
        <DraggableStickers />
      </div>

      {/* 右侧应用展示区域 */}
      <div className="right-section">
        <OurApps />
      </div>
    </div>
  );
};

export default Home;